import React, { useEffect } from 'react'

import { BigCalendarGlobal } from './components/global/BigCalendarFormGlobal'
import { BigCalendarModalFooterGlobalProps } from './components/global/components/modal/BigCalendarModalFooterGlobal'
import { BigCalendarIndividual } from './components/individual/BigCalendarIndividual'
import { BigCalendarHeaderICalendarImportProps } from './components/shared/calendar/components/header/components/BigCalendarHeaderImportButton'
import { BigCalencarFormProvider } from './components/shared/calendar/utils/use-big-calendar-form'
import {
  isHouseGlobal,
  isHouseIndividual,
} from './helpers/assert-house-price-type'
import { HouseContextOwnerFragment } from '../../../lib/graphql'

type HouseBigCalendarProps = Pick<
  BigCalendarHeaderICalendarImportProps,
  'onUpdateICalendarUrls'
> &
  Pick<
    BigCalendarModalFooterGlobalProps,
    | 'onUpsertHouseAvailability'
    | 'onUpsertManyHouseAvailabilities'
    | 'isFormDisabled'
  > & {
    house: HouseContextOwnerFragment
    onKeepUpToDateHouseAvailabilityICalendar: {
      isLoading: boolean
      mutate: () => void
    }
  }
export const HouseBigCalendar = (props: HouseBigCalendarProps) => {
  const {
    house,
    onKeepUpToDateHouseAvailabilityICalendar: {
      mutate: onUpsertHouseAvailabilityICalendar,
    },
  } = props

  useEffect(() => {
    onUpsertHouseAvailabilityICalendar()
  }, [])
  return (
    <BigCalencarFormProvider>
      <div className='rounded-6 flex-[2] overflow-hidden rounded-md bg-white'>
        {isHouseGlobal(house) ? (
          <BigCalendarGlobal {...props} house={house} />
        ) : isHouseIndividual(house) ? (
          <BigCalendarIndividual {...props} house={house} />
        ) : null}
      </div>
    </BigCalencarFormProvider>
  )
}
